import { IHeroSlider } from '../types/hero-slider-t';






// hero slider three
const hero_slider: IHeroSlider[] = [
  // {
  //   id: 1,
  //   bgImg: '/assets/img/slider/slider-1.jpg',
  //   title: 'Handmade <br> Hand carved Coffee',
  //   subtitle:
  //     'As rich and unique as the coffee beans it is intended for, this little scoop will make your morning ritual a special occasion every day.',
  // },
  {
    id: 2,
    bgImg: '/assets/img/slider/slider-2.jpg',
    title: 'Best Sellers <br>Highly Rated Printers',
    subtitle:
      'Make the easy choice. Find the right home and office printers based on their popularity and positive buyer reviews.',
  },
  {
    id: 3,
    bgImg: '/assets/img/slider/slider-3.jpg',
    title: 'Rethink. Reimagine. <br> Revolutionize.',
    subtitle:
      'Open up a new world of possibilities for productivity and interaction.',
  },
];



export const HeroSliderData = {
  hero_slider,
};
